import { rehydrateDateAfterJsonization as w } from "../util/date-utils.js";
export default class ti {
  constructor(t, i, s, l, h) {
    (this.endpoint = t),
      (this.Cn = i),
      (this.publicKey = s),
      (this.Vl = l),
      (this.cl = h),
      (this.endpoint = t || null),
      (this.Cn = i || null),
      (this.publicKey = s || null),
      (this.Vl = l || null),
      (this.cl = h || null);
  }
  Y() {
    return {
      e: this.endpoint,
      c: this.Cn,
      p: this.publicKey,
      u: this.Vl,
      v: this.cl,
    };
  }
  static En(t) {
    return new ti(t.e, w(t.c), t.p, t.u, t.v);
  }
}
